<template>
    <div>
        <div v-if="page.total==0&&!page.loading">
            暂无内容
        </div>
        <div v-else>
            <ul class="news-list">
                <li v-for="item in page.data">
                    <router-link :to="{name:'content_detail',params:{channelId:channelId,articleId:item.id}}">
                        <Row>
                            <Col :md="18">
                                <Icon type="ios-arrow-forward" />
                                {{item.name}}
                            </Col>
                            <Col :md="6" span="0" style="text-align: right">
                                {{dateFormat(item.issueTime)}}
                            </Col>
                        </Row>
                    </router-link>
                </li>
            </ul>
            <div class="table-page-wrap" >
                <Page size="small" @on-change="toPage" simple :current="page.index" :total="page.total" :page-size="page.size" show-total ></Page>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .news-list{
        font-size: 14px;
        line-height: 40px;
        list-style: none;
        margin: 0;
        & >li{
            /*padding: 0 10px;*/
            border-bottom: 1px dotted rgb(234,234,234);
        }
    }
</style>
<script>
    import {dateFormat} from '../../common/tool';
    import service from "../../common/service";

    const channelService  = new service({baseUrl:'/web/channel/'});
    export default {
        data() {
            return {
                page:{
                    data:[],
                    loading:false,
                    total:0,
                    index:1,
                    size:10,
                    params:{}
                },
            }
        },
        props:['channelId'],
        components: {},
        watch:{
            'channelId'(){
                this.page.total = 0;
                this.page.data = [];
                this.toPage(1);
            }
        },
        created(){
            this.toPage(1);
        },
        methods:{
            dateFormat(d){
                return dateFormat(d);
            },
            fetch(){
                let self = this;
                if(this.channelId){
                    let p = {page:this.page.index,size:this.page.size,'o_o$issueTime':'desc','o_o$modifyTime':'desc'};

                    channelService.postForm(`${this.channelId}/articles`,p).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let data = json.data;
                            self.page.index = data.page;
                            self.page.total = data.total;
                            self.page.data = [...data.data];
                        }
                    })
                }
            },
            toPage(v){
                this.page.index = v;
                this.fetch();
            },
        }
    }
</script>
